import { useMutation } from '@tanstack/react-query';
import { requestCreatePassword } from "../queries/fetchAuth";

export function useCreatePassword() {
  const { data, mutate, isError, error, isSuccess, isPending } = useMutation({
    mutationKey: ['auth-create-password'],
    mutationFn: ({ password, token }: { password: string, token: string }) => requestCreatePassword(token, password),
    retry: false
  });

  return {
    data,
    mutate,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
  }
}
